import React from 'react';
import { Box, Typography } from '@mui/material';

export default function EmptyState({ title, description, action }) {
  return (
    <Box
      sx={{
        px: 3,
        py: 6,
        textAlign: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        backgroundColor: 'background.paper',
      }}
    >
      <Typography variant="h3" component="h2">
        {title}
      </Typography>
      {description ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: action ? 2 : 0 }}>
          {description}
        </Typography>
      ) : null}
      {action || null}
    </Box>
  );
}
